window.AvailabilityAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    self.add = function (data) {
        var deferred = $q.defer();

        _protected.request('availability', 'PUT', data).then(function (res) {
            if (res && res.data && res.data.status_code == 200) {
                deferred.resolve(res.data);
            }
        }, (err) => {
            if (err.status === 400) {
                self.save(data)
                    .then(function (data) {
                        deferred.resolve(data);
                    }, function (err) {
                        deferred.reject(err);
                    });
            } else {
                deferred.reject(err.data);
            }
        });
        return deferred.promise;
    };

    self.save = function (data) {
        var deferred = $q.defer();
        _protected.request('availability', 'POST', data).then(function (data) {
            _protected.handleResponse(data.data, deferred);
        }, function(err){
            deferred.reject(err.data);
        });
        return deferred.promise;
    };

    self.load = function() {
        var deferred = $q.defer();

        _protected.request("availability", "GET")
            .then(function(res){

                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    }
});
